import { useTranslation } from 'react-i18next';
import { useWatchSocketData } from 'features/hmi/contexts/WatchSocketContext';
import { useHasInitialWatchData } from 'features/hmi/hooks/useHasInitialWatchData';
import { StartupWizard, unwrapCommandFeedback, useIsBatteryStartupSequence } from 'greener-ui-library';
import useAuth from 'hooks/useAuth';
import { useBreakpoint } from 'hooks/useBreakpoint';
import { useSnackbar } from 'notistack';
import { canOperateWatch } from 'utils/authorization';

export const HmiStartupWizard = () => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { messages, sendCommand } = useWatchSocketData();
  const hasInitialData = useHasInitialWatchData();
  const isBatteryStartupSequence = useIsBatteryStartupSequence(messages, hasInitialData);
  const { isMobile } = useBreakpoint();
  const { user } = useAuth();

  if (!canOperateWatch(user?.role) || !isBatteryStartupSequence) {
    return null;
  }

  const turnOnBatteries = async () => {
    try {
      const data = unwrapCommandFeedback(await sendCommand('turn_batteries_on', undefined));
      enqueueSnackbar(data.detail || t('projects:hmi.commandCenter.feedback.success'), { variant: 'success' });
    } catch (error) {
      enqueueSnackbar(
        error instanceof Error && error.message ? error.message : t('projects:hmi.commandCenter.feedback.error'),
        { variant: 'error' }
      );
      throw error;
    }
  };

  return <StartupWizard messages={messages} isMobile={isMobile} onTurnOnBatteries={turnOnBatteries} />;
};
